angular.module('admin.subscriptions').controller('EditOrganizationCtrl', function (organization, $uibModalInstance, $http, config, CnpjUtils) {
    this.organization = Object.assign({}, organization);
    this.organization.cnpj = CnpjUtils.normalize(this.organization.cnpj);

    this.update = function () {

        const data = {
            organizationId: this.organization.id,
            cnpj: CnpjUtils.normalize(this.organization.cnpj)
        };
        $http({
            url: `${config.api}/api/v1/user-management/organization/cnpj`,
            method: 'PATCH',
            isArray: false,
            data: data
        }).then(res => {
            Object.assign(organization, data);
            $uibModalInstance.close();
        });
    }
    this.cancel = function () {
        $uibModalInstance.dismiss();
    }

})